window.$ = window.JQuery = require('jquery');

import Alpine from 'alpinejs';
import dialog from '@fylgja/alpinejs-dialog';

import header from './components/header'
import careHomeMenu from './components/care-home-menu'
import homes from './components/homes'
import heroCarousel from './components/carousels/hero-carousel'
import imageCarousel from './components/carousels/image-carousel';
import testimonialCarousel from './components/carousels/testimonial-carousel';

// import reviews from './components/reviews'
import map from './components/map'
import videoModal from './components/video-modal'
import timeline from './components/timeline'

import careHomeAccommodationCarousel from './components/carousels/care-home-carousel';

window.Alpine = Alpine;

Alpine.plugin(dialog);

Alpine.data('header', header)
Alpine.data('careHomeMenu', careHomeMenu)
Alpine.data('homes', homes)
Alpine.data('heroCarousel', heroCarousel)
Alpine.data('imageCarousel', imageCarousel)
Alpine.data('testimonialCarousel', testimonialCarousel)
// Alpine.data('reviews', reviews)
Alpine.data('careHomeAccommodationCarousel', careHomeAccommodationCarousel);
Alpine.data('map', map)
Alpine.data('videoModal', videoModal)
Alpine.data('timeline', timeline)

Alpine.start()

// if (window.config.NAVIGATION_WHITE_BY_DEFAULT === true && window.config.IGNORE_HEADER_RESIZE === false) {
//     document.addEventListener('DOMContentLoaded', function () {
//         generateMainMargin();

//         window.addEventListener('resize', generateMainMargin);
//     });
// }

// function generateMainMargin() {
//     let header = document.querySelector('header');

//     if (header !== null) {
//         document.querySelector('main').style.marginTop = header.clientHeight + 'px';
//     }
// }

$(function()
{
    boot();
});


function boot() {
    postIndex();
    form();
}

function form()
{
    if ($('#other-wrapper').length && $('#where_did_you_hear_about_us').length) {
        $('#other-wrapper').addClass('hidden');
        
        $('#where_did_you_hear_about_us').on('change', function() {
            var selectedValue = $(this).val();
            
            if (selectedValue === 'Other') {
                $('#other-wrapper').removeClass('hidden');
            } else {
                $('#other-wrapper').addClass('hidden');
            }
        });
    }
}

function loadPostData(href) {

    $('html,body').animate({scrollTop: $("#post-filter").offset().top - $('#header').height() }, 100);

    $("#article-panel-wrapper").append($('<div></div>').addClass('loading'));

    $("#article-panel-wrapper").load(href+" #article-panel-inner-wrapper", function() {
    });

    var stateObj = {};
    window.history.pushState(stateObj, "", href);
}

function postIndex() {

    if($('#post-filter').length == 0) {
      return;
    }

    $(document.body).on('submit', '#post-filter' ,function(event) {
        event.preventDefault();
        loadPostData($('#post-filter').attr('action')+'?'+$('#post-filter').serialize());
    });

    $(document.body).on('change', '#job_location' ,function(event) {
        event.preventDefault();
        loadPostData($('#post-filter').attr('action')+'?'+$('#post-filter').serialize());
    });

    $(document.body).on('change', '#job_role' ,function(event) {
        event.preventDefault();
        loadPostData($('#post-filter').attr('action')+'?'+$('#post-filter').serialize());
    });

    $(document.body).on('click', '.pagination a' ,function(event) {
        event.preventDefault();
        loadPostData($(this).prop('href'));
    });

}